import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import VendorDiligenceCreateModalUI from './VendorDiligenceCreateModalUI';

class VendorDiligenceCreateModalSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successMsg: null,
      errorList: [],
      messageList: [],
      companyName: '',
      companyNameError: null,
      isSubmitting: false
    };
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  onSubmit = () => {
    if (this.validateForm()) {
      return;
    }

    this.setState({
      successMsg: null,
      errorList: [],
      isSubmitting: true
    });

    RestApiUtils.post(
      this.props.context,
      `/api/su/accounts/cin`,
      this.getCinCallback,
      {
        companyName: this.state.companyName
      }
    );
  };

  getCinCallback = (response) => {
    if (response && response.errorList && response.errorList.length > 0) {
      const errorMessages = response.errorList.map(error => error.message);
      this.setState({
        errorList: errorMessages,
        companyNameError: response.errorList[0].message,
        isSubmitting: false
      });
    } else {
      RestApiUtils.post(
        this.props.context,
        `/api/su/vendorDiligence/placeOrder`,
        this.getPlaceOrderCallback,
        {
          vendorName: this.state.companyName,
          cin: response.cin       
         }
      );
    }
  };

  getPlaceOrderCallback = (response) => {
    if (response && response.errorList && response.errorList.length > 0) {
      const errorMessages = response.errorList.map(error => error.message);
      this.setState({ 
        errorList: errorMessages,
        isSubmitting: false
      });
    } else {
      console.log("✅ Order placed successfully:", response);
      this.setState({
        successMsg: "Vendor diligence order created successfully",
        isSubmitting: false
      });
      
      setTimeout(() => {
        this.resetForm();
        this.props.onRefreshClick();
        this.props.onCancelClick();
      }, 1500);
    }
  };

  validateForm = () => {
    let hasErrors = false;
    const newErrorsObj = {};
    const newErrorsList = [];

    if (!this.state.companyName) {
      newErrorsObj.companyNameError = 'Company Name is required';
      newErrorsList.push('Company Name is required');
      hasErrors = true;
    }

    this.setState({
      ...newErrorsObj,
      errorList: newErrorsList
    });

    return hasErrors;
  };

  resetForm = () => {
    this.setState({
      successMsg: null,
      companyName: '',
      companyNameError: null,
      errorList: [],
      isSubmitting: false
    });
  };

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList });
  };

  render() {
    return (
      <VendorDiligenceCreateModalUI
        context={this.props.context}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        messageList={this.state.messageList}
        createMode={this.props.createMode}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        companyName={this.state.companyName}
        onCompanyNameChange={(event) => { this.setState({ companyName: event.target.value }) }}
        companyNameError={this.state.companyNameError}
        setCompanyNameError={(error) => { this.setState({ companyNameError: error }) }}
        isSubmitting={this.state.isSubmitting}
      />
    );
  }
}

export default withRouter(VendorDiligenceCreateModalSF);